import { Box, styled, Typography } from '@mui/material';

export const CardMediaBox = styled(Box)`
  height: 270px;
`;

export const CardMediaWrapper = styled(Box)`
  top: 50%;
  transform: translate(0%, -50%);
  position: relative;
  height: fit-content;
`;

export const DescContainerBox = styled(Box)`
  height: auto;
`;

export const LayoutInfoCard = styled(Box)(
  ({ theme }) =>
    `
  width: 274px;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: ${theme.palette.secondary.lightest};
  padding: 16px 13px;
  padding-top: 60px;
  border-radius: 18px;
  gap: 10px;
  justify-content: space-around;

  &:hover {
    cursor: pointer;
  }
`,
);

export const LayoutTitle = styled(Typography)`
  font-weight: 500;
  margin-top: 0.5rem;
`;

export const LayoutText = styled(Typography)`
  font-size: 0.875rem;
  font-weight: 300;
  margin-left: 8px;
`;

export const LayoutChipContainer = styled(Box)`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 4px;
  height: 30px;
`;

export const LayoutInfoContainer = styled(Box)`
  width: 100%;
  display: flex;
  gap: 4px;
  align-items: center;
  margin-top: 0.3rem;
`;
